import { useContext, useSyncExternalStore } from 'react';
import { ReactReduxContext } from 'react-redux';
import { selectUser } from '@common-reducers/UserSelectors';
import { toClockPreference, type ClockPreference } from '@common/config/time-format';

const noopSubscribe = () => () => undefined;

/**
 * The signed-in user's saved 12h/24h display preference (`users.preferences.timeFormat`).
 * Safe outside a redux Provider (returns undefined), so leaf pickers can use it in isolation.
 */
export function useClockPreference(): ClockPreference | undefined {
  const store = useContext(ReactReduxContext)?.store;
  const read = () => {
    if (!store) return undefined;
    try {
      return toClockPreference(selectUser(store.getState())?.preferences?.timeFormat);
    } catch {
      return undefined; // partial store: show the locale default rather than break the render
    }
  };
  return useSyncExternalStore(store ? store.subscribe : noopSubscribe, read, read);
}
